import { render, staticRenderFns } from "./Blob.vue?vue&type=template&id=2c67b94a&"
import script from "./Blob.vue?vue&type=script&lang=js&"
export * from "./Blob.vue?vue&type=script&lang=js&"
import style0 from "./Blob.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports